<template>
    <div class="navWrap">
      <div class="navWrap_center">
        <div>
          <img src="../assets/img/logo.png" alt="" />
        </div>

        <div class="dropdown">
            <div class="dropdown-content">
                <RouterLink :class="[btnIndex == 0 ? 'nowSelect' : '']" to="/">首页</RouterLink>
                <RouterLink :class="[btnIndex == 1 ? 'nowSelect' : '']" to="/appCenter">产品中心</RouterLink>
                <RouterLink :class="[btnIndex == 2 ? 'nowSelect' : '']" to="/Company">公司介绍</RouterLink>
                <RouterLink :class="[btnIndex == 3 ? 'nowSelect' : '']" to="/addWe">加入我们</RouterLink>
            </div>
        </div>

        <button class="dropbtn" @click="openPop">获取方案</button>
      </div>
      <div class="page" v-if="secViewName != ''">
        <div class="text-span"><dev :style="{cursor:'pointer'}" :onClick="toApp">产品中心</dev> > {{ secViewName }}</div>
      </div>
    </div>
  </template>
  
  <script>
  import callWe from "../components/callWe.vue"
  export default {
    name: 'mainHome',
    components:{
        callWe
    },
    data() {
        return {
        }
    },
    props: {
        secViewName:String,
        btnIndex:Number,
        changePop:Function
    },
    methods: {
        toApp() {
			this.$router.push("/appCenter");
		},
        openPop(){
            this.changePop(true)
        }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="less">
    /* 导航部分 */
    .navWrap {
        width: 1280px;
        margin: auto;
        height: 78px;
    }

    .navWrap_center {
        
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dropdown {
        height: 78px;
    }
    
    .dropdown-content {
        display: inline-block;
        text-align: center;
        line-height: 70px;
        margin-left: 16px;
    }
    
    .dropdown-content a {
        color: rgb(6, 6, 6);
        margin-left: 20px;
        display: inline-flex;
        cursor: pointer;
        text-decoration: none;
    }
    
    .dropdown-content .nowSelect {
        border-bottom: 3px solid #CB2B16
    }
    
    .dropdown-content a:hover {
        color: #f43a3a;
    }

    
    .dropbtn {
        height: 38px;
        width: 128px;
        border-radius: 4px;
        border: 1px solid #CB2B16;
        cursor: pointer;

        font-family: Noto Sans SC;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        color: #CB2B16;
        background-color: white;

        margin-left: 400px;
    }

    .page{
        font-family: Noto Sans SC;
        font-size: 14px;
        font-weight: 400;
        line-height: 48px;
        text-align: center;
        height: 48px;
        border-top: 1px solid #EAEAEA;
        border-bottom: 1px solid #EAEAEA;
        max-width: 980px;
        margin: auto;
    }

    .page .text-span{
        margin: auto;
        text-align: left;
        width: 980px;
    }
  </style>
  